<script setup lang="ts">
import { computed } from 'vue';
import { exceptionIconDisplaysFromFlags } from '@/utils/shipment-exception-display';

const props = defineProps<{
  flags?: number | null;
}>();

const items = computed(() => exceptionIconDisplaysFromFlags(props.flags));
</script>

<template>
  <div
    v-if="items.length"
    class="flex items-center gap-1"
    role="list"
    aria-label="Shipment exceptions"
  >
    <i
      v-for="item in items"
      :key="item.severity"
      role="listitem"
      :class="[
        'pi mt-px shrink-0 text-sm leading-none',
        item.icon,
        item.colorClass,
      ]"
      :title="item.tagLabel"
      :aria-label="item.tagLabel"
    />
  </div>
  <span v-else class="text-sm text-gray-400">—</span>
</template>
